import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/features/shop/components/ShopPageContent.tsx");
